module.exports = __webpack_public_path__ + "static/media/facts_bg.da7ba2a0.jpg";